module.exports = __webpack_public_path__ + "static/media/37F55A_0_0.163ea966.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/37F55A_0_0.woff2
// module id = 738
// module chunks = 0